const breadCrumb = "Lançamento de Notas - Relatório de Notas";

const routes = [
  {
    path: "/emitir-boletim-por-aluno",
    name: "emitir-boletim-por-aluno",
    meta: {
      allowedPermissions: ["aluno_avaliacao_nota_emitir_boletim_por_aluno"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/EmitirBoletimPorAluno/EmitirBoletimPorAluno.vue"),
  },
];

export default routes;
